import { ISortByField } from "../types/ITable";

export function sortByFields<T>(
  fields: Array<ISortByField<T>>,
): (a: T, b: T) => number {
  const compareString = (a: T[keyof T] | string, b: T[keyof T] | string) =>
    String(a).localeCompare(String(b));

  const compareNumber = (a: T[keyof T] | string, b: T[keyof T] | string) =>
    Number(a) - Number(b);

  return (a: T, b: T) =>
    fields
      .map(({ name, ascending, isNumeric, sortValueFunction }) => {
        const dir = ascending ? 1 : -1;

        const compareFn = isNumeric ? compareNumber : compareString;

        const aVal = sortValueFunction ? sortValueFunction(a) : a[name];
        const bVal = sortValueFunction ? sortValueFunction(b) : b[name];

        if (aVal === bVal) return 0;

        if (aVal === undefined && bVal === undefined) return 0;
        if (aVal === undefined) return -dir;
        if (bVal === undefined) return dir;

        if (compareFn(aVal, bVal) > 0) return dir;
        if (compareFn(aVal, bVal) < 0) return -dir;
        return 0;
      })
      .reduce((p, n) => (p ? p : n), 0);
}
